export function filterArrayDuplicates<T>(
  array: T[],
  compareFunc: (a: T, b: T) => boolean = (a, b) => a === b,
  removeNullUndefined: boolean = true
): T[] {
  const arrayToFilter = removeNullUndefined
    ? array.filter((el) => el != null)
    : array;
  return arrayToFilter.filter((el, index) => {
    return (
      arrayToFilter.findIndex((compareEl) => compareFunc(el, compareEl)) ===
      index
    );
  });
}
